import { FC, PropsWithChildren, useEffect } from 'react';

import { useSetIsOnline } from '@/store/application';

type ApplicationProviderProps = PropsWithChildren<{}>;

export const ApplicationProvider: FC<ApplicationProviderProps> = ({
    children,
}) => {
    const setIsOnline = useSetIsOnline();

    useEffect(() => {
        const onOnline = () => {
            setIsOnline(true);
        };

        const onOffline = () => {
            setIsOnline(false);
        };

        window.addEventListener('online', onOnline);
        window.addEventListener('offline', onOffline);

        return () => {
            window.removeEventListener('online', onOnline);
            window.removeEventListener('offline', onOffline);
        };
    }, []);

    return <>{children}</>;
};
